export default __webpack_public_path__ + "static/icon-tile-dark-30d6c5a46b14323498085cabee2d4bb8.png";